const ExpandableRowComponent = ({ data }) => (
  <ul className="dtr-details p-2 border-bottom ml-1">
    {Object.entries(data).map(([key, value]) => (
      <li className="d-block">
        <span className="dtr-title">{key}</span>{' '}
        <span className="dtr-data">{value || '-'}</span>
      </li>
    ))}
  </ul>
);

export default ExpandableRowComponent;
